import { Get, Post } from "../utils/http-utils";

export const getUploadedFilesForDevice = async (queryParams) => {
    return Get("/uploaded-files", queryParams)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });

}

export const downloadSelectedFiles = async (jsonPayload) => {
    return Post("/uploaded-files/download", jsonPayload)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });

}